import * as React from "react";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { SetState } from "source/app/services/UI/State/SetState";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { IStacksContainerState } from "./IStacksContainerState";

export function AdjustStackDifficulty({
    activeCellIndex,
}: {
    activeCellIndex: number;
}) {
    return (
        <span style={{ opacity: 0.6, margin: `0px 10px` }}>
            <IconWithText
                iconSuffix={EGlyphicon.minus}
                displayAsBlock={false}
                withClass={GetButtonStyleClass()}
                whenClicked={() => ChangeStackDifficulty(-1)}
            />
            <span
                style={{
                    fontSize: "26px",
                    margin: "0px 10px",
                    color: activeCellIndex <= 1 ? `#fd956e` : `inherit`,
                }}
            >
                {activeCellIndex + 1}
            </span>
            <IconWithText
                iconSuffix={EGlyphicon.plus}
                displayAsBlock={false}
                withClass={GetButtonStyleClass()}
                whenClicked={() => ChangeStackDifficulty(1)}
            />
        </span>
    );
}

export function ChangeStackDifficulty(offset: number) {
    const stacksContainerState = ReadState<IStacksContainerState>(
        ESharedFunction.Stacks_state
    );

    if (!stacksContainerState) {
        return;
    }

    SetState(ESharedFunction.Stacks_state, {
        activeCellIndex: stacksContainerState.activeCellIndex + offset,
    });
}

function GetButtonStyleClass(): string {
    return StyleClass(`adjutsStacksDifficultyButton`, {
        background: "dimgray",
        padding: "5px",
        borderRadius: "4px",
        position: `relative`,
        bottom: `4px`,
        ":hover": {
            border: `1px solid white`,
        },
        ":active": {
            background: `white`,
            color: `black`,
        },
    });
}
